var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { NFoldProduct2 } from "@rendering/vortex-paper-products";
import { loadFinishMap, loadSubstrateMap } from "./materialLoader";
export function getNfoldProduct(productConfig) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a, _b, _c;
    const response = yield fetch(productConfig.productDataUrl);
    if (!response.ok) {
      if ((_a = response.headers.get("content-type")) === null || _a === void 0 ? void 0 : _a.includes("application/json")) {
        const data = yield response.json();
        throw new Error("Failed to fetch NFoldData from '".concat(productConfig.productDataUrl, "': ").concat(JSON.stringify(data), "}"));
      }
      throw new Error("Failed to fetch NFoldData from '".concat(productConfig.productDataUrl, "'!"));
    }
    const nFoldData = yield response.json();
    const sectionSets = [];
    // Load all the substrates and finishes
    const substrateMap = yield loadSubstrateMap(productConfig);
    const finishMap = yield loadFinishMap(productConfig);
    // Create each section set in the nFoldData
    for (const sectionSet of nFoldData.sectionSets) {
      const sections = [];
      // Create each section in the nFold data
      for (const sectionData of sectionSet.sections) {
        // Build the product surface ids for the front, back, and body
        const frontId = "".concat(sectionData.id, ":Front");
        const bodyId = "".concat(sectionData.id, ":Body");
        const backId = "".concat(sectionData.id, ":Back");
        // Ensure all those surfaces exist
        if (!productConfig.surfaceMapping[frontId] || !productConfig.surfaceMapping[bodyId] || !productConfig.surfaceMapping[backId]) {
          throw new Error("The surface mapping must contain three surfaces (front, body, and back) for section!");
        }
        // Get the all the surfaces
        const frontSurface = productConfig.surfaceMapping[frontId];
        const bodySurface = productConfig.surfaceMapping[bodyId];
        const backSurface = productConfig.surfaceMapping[backId];
        // Build the section
        const section = {
          id: sectionData.id,
          path: sectionData.path,
          frontSide: {
            page: frontSurface.page,
            contentOffset: (_b = frontSurface.contentOptions) === null || _b === void 0 ? void 0 : _b.offset,
            substrate: substrateMap[frontSurface.substrateId],
            focalPoint: frontSurface.focalPoint
          },
          backSide: {
            page: backSurface.page,
            contentOffset: (_c = backSurface.contentOptions) === null || _c === void 0 ? void 0 : _c.offset,
            substrate: substrateMap[backSurface.substrateId],
            focalPoint: backSurface.focalPoint
          },
          bodySubstrate: substrateMap[bodySurface.substrateId]
        };
        // Add finishes to the front surface if they exist
        if (frontSurface.finishIds) {
          section.frontSide.finishes = [];
          for (const finishId of frontSurface.finishIds) {
            section.frontSide.finishes.push(finishMap[finishId]);
          }
        }
        // Add finishes to the back surface if they exist
        if (backSurface.finishIds) {
          section.backSide.finishes = [];
          for (const finishId of backSurface.finishIds) {
            section.backSide.finishes.push(finishMap[finishId]);
          }
        }
        // Add any filled in sections
        if (sectionData.path.fills) {
          section.fillSubstrates = [];
          for (let i = 0; i < sectionData.path.fills.length; i++) {
            const bodyFillId = "".concat(sectionData.id, ":Body Fill:").concat(i);
            if (!productConfig.surfaceMapping[bodyFillId]) {
              throw new Error("The surface mapping must include '".concat(bodyFillId, "' because the path has fill sections!"));
            }
            const fillSurface = productConfig.surfaceMapping[bodyFillId];
            section.fillSubstrates.push(substrateMap[fillSurface.substrateId]);
          }
        }
        sections.push(section);
      }
      // Add a new section set
      sectionSets.push({
        id: sectionSet.id,
        name: sectionSet.name,
        fullBleed: sectionSet.fullBleed,
        trim: sectionSet.trim,
        thickness: sectionSet.thickness,
        baseSectionId: sectionSet.baseSectionId,
        sections,
        folds: sectionSet.folds,
        foldSequences: sectionSet.foldSequences,
        rotationOffset: sectionSet.rotationOffset,
        positionOffset: sectionSet.positionOffset
      });
    }
    // Generate the final nfold config
    const nFoldConfig = {
      sectionSets
    };
    return new NFoldProduct2(nFoldConfig);
  });
}